var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 0C5.85775 0 5.45575 0.138 5.1715 0.42225C4.888 0.705 4.75 1.107 4.75 1.5V2.25H0.25V3.75H1V15.75C1 16.9837 2.01625 18 3.25 18H12.25C13.4838 18 14.5 16.9837 14.5 15.75V3.75H15.25V2.25H10.75V1.5C10.75 1.10775 10.612 0.70575 10.3278 0.4215C10.045 0.138 9.64225 0 9.25 0H6.25ZM6.25 1.5H9.25V2.25H6.25V1.5ZM2.5 3.75H13V15.75C13 16.1663 12.6663 16.5 12.25 16.5H3.25C2.83375 16.5 2.5 16.1663 2.5 15.75V3.75ZM4 6V14.25H5.5V6H4ZM7 6V14.25H8.5V6H7ZM10 6V14.25H11.5V6H10Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.513d28e03dca3528c54cfc2fb85993fc.svg";
export { ForwardRef as ReactComponent };